import type { CreatorStatus } from '@/types';
import { VALID_TRANSITIONS } from '../types';

export function canTransition(
  from: CreatorStatus,
  to: CreatorStatus,
  isAdmin: boolean
): boolean {
  if (isAdmin) return true;
  if (from === to) return false;
  return VALID_TRANSITIONS[from].includes(to);
}

export function getValidTargets(
  from: CreatorStatus,
  isAdmin: boolean
): CreatorStatus[] {
  if (isAdmin) {
    return [
      'new',
      'contacted',
      'negotiating',
      'closed_won',
      'closed_lost',
      'promotion',
    ].filter((s) => s !== from) as CreatorStatus[];
  }
  return VALID_TRANSITIONS[from];
}
